/**
 * Node.js polyfills for browser (required by ExcelJS and similar deps).
 * Must be imported first, before any code that uses these globals.
 */
import { Buffer } from 'buffer';
import process from 'process/browser';
import stream from 'stream-browserify';

(globalThis as any).Buffer = Buffer;
(globalThis as any).process = process;
(globalThis as any).stream = stream;

// Ensure process.version and process.versions.node for ExcelJS/readable-stream
if (!(globalThis as any).process.version) (globalThis as any).process.version = 'v18.0.0';
if (!(globalThis as any).process.versions) (globalThis as any).process.versions = {};
if (!(globalThis as any).process.versions.node) (globalThis as any).process.versions.node = '18.0.0';

// Add Vite env vars to process.env (Vite's define doesn't work when process is a real object)
if (!(globalThis as any).process.env) (globalThis as any).process.env = {};
// Copy all import.meta.env variables to process.env
Object.keys(import.meta.env).forEach((key) => {
  (globalThis as any).process.env[key] = (import.meta.env as any)[key];
});
// Add PUBLIC_URL for CRA compatibility (Vite uses BASE_URL instead)
// Remove trailing slash to match CRA behavior: PUBLIC_URL is '' for root or '/subpath' for subdirectory
(globalThis as any).process.env.PUBLIC_URL = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');

// Minimal CommonJS shim for deps that reference `module`
if (typeof (globalThis as any).module === 'undefined') {
  const mod = { exports: {} };
  (globalThis as any).module = mod;
  (globalThis as any).exports = mod.exports;
}

